// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.staffing-and-training-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  gap: 20px;
  margin-bottom: -50px;
}

.staffing-and-training-image {
  position: relative;
  width: 35%;
  order: 1;
  margin-top: 20px;
}

.services-image {
  width: 100%;
  height: auto;
  border-radius: 8px;
  margin-top: -50px;
}

.staffing-and-training-text {
  width: 60%;
  order: 2;
  margin-top: -60px;
}

.staffing-and-training-text h1 {
  font-size: 2em;
  color: #000;
  margin-bottom: 10px;
}

.staffing-and-training-text p {
  font-size: 1em;
  color: #555;
  margin-bottom: 20px;
}

.services-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  list-style: none;
  padding: 0;
}

.services-list li {
  width: 45%;
  font-size: 0.9em;
  color: #333;
}

.staffing-and-training-button {
  background-color: #00c853;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 1em;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 20px;
  transition: background-color 0.3s ease;
}

.staffing-and-training-button:hover {
  background-color: #009624;
}

@media (max-width: 768px) {
  .staffing-and-training-container {
    flex-direction: column;
    align-items: center;
    text-align: start;
    gap: 20px;
  }

  .staffing-and-training-text {
    width: 80%;
    order: 2;
    margin-bottom: 40px;
  }

  .staffing-and-training-image {
    width: 100%;
    order: 1;
  }

  .services-list li {
    width: 100%;
  }
}

@media (min-width: 1920px) and (max-width: 1920px) {
  .staffing-and-training-container {
    padding: 50px;
  }

  .staffing-and-training-image {
    width: 25%;
  }

  .staffing-and-training-text {
    width: 70%;
  }

  .services-list li {
    width: 40%;
  }
}

@media (min-width: 1380px) and (max-width: 1919px) {
  .staffing-and-training-container {
    padding: 30px;
  }

  .staffing-and-training-image {
    width: 32%;
  }

  .staffing-and-training-text {
    width: 63%;
  }

  .services-list li {
    width: 45%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/StaffingAndTrainingServices/StaffingAndTrainingServices.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,UAAU;IACV,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".staffing-and-training-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px;\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  gap: 20px;\n  margin-bottom: -50px;\n}\n\n.staffing-and-training-image {\n  position: relative;\n  width: 35%;\n  order: 1;\n  margin-top: 20px;\n}\n\n.services-image {\n  width: 100%;\n  height: auto;\n  border-radius: 8px;\n  margin-top: -50px;\n}\n\n.staffing-and-training-text {\n  width: 60%;\n  order: 2;\n  margin-top: -60px;\n}\n\n.staffing-and-training-text h1 {\n  font-size: 2em;\n  color: #000;\n  margin-bottom: 10px;\n}\n\n.staffing-and-training-text p {\n  font-size: 1em;\n  color: #555;\n  margin-bottom: 20px;\n}\n\n.services-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  list-style: none;\n  padding: 0;\n}\n\n.services-list li {\n  width: 45%;\n  font-size: 0.9em;\n  color: #333;\n}\n\n.staffing-and-training-button {\n  background-color: #00c853;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  font-size: 1em;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 20px;\n  transition: background-color 0.3s ease;\n}\n\n.staffing-and-training-button:hover {\n  background-color: #009624;\n}\n\n@media (max-width: 768px) {\n  .staffing-and-training-container {\n    flex-direction: column;\n    align-items: center;\n    text-align: start;\n    gap: 20px;\n  }\n\n  .staffing-and-training-text {\n    width: 80%;\n    order: 2;\n    margin-bottom: 40px;\n  }\n\n  .staffing-and-training-image {\n    width: 100%;\n    order: 1;\n  }\n\n  .services-list li {\n    width: 100%;\n  }\n}\n\n@media (min-width: 1920px) and (max-width: 1920px) {\n  .staffing-and-training-container {\n    padding: 50px;\n  }\n\n  .staffing-and-training-image {\n    width: 25%;\n  }\n\n  .staffing-and-training-text {\n    width: 70%;\n  }\n\n  .services-list li {\n    width: 40%;\n  }\n}\n\n@media (min-width: 1380px) and (max-width: 1919px) {\n  .staffing-and-training-container {\n    padding: 30px;\n  }\n\n  .staffing-and-training-image {\n    width: 32%;\n  }\n\n  .staffing-and-training-text {\n    width: 63%;\n  }\n\n  .services-list li {\n    width: 45%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
